import { getAuthAxios } from "@artprov/design-system";

/**
 * Servicio para interactuar con el endpoint de matching judicial
 */

/**
 * Obtiene el detalle de un registro específico de matching judicial
 * @param {number} idEmail - ID del email
 * @param {number} idJuicio - ID del juicio
 * @returns {Promise<Object>} Detalle del registro
 */
export const getMatchingJudicialDetalle = async (idEmail, idJuicio) => {
    try {
        const response = await getAuthAxios("default").get(
            `judicial/matching-judicial/detalle`,
            {
                params: { idEmail, idJuicio }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error al obtener detalle de matching judicial:', error);
        throw error;
    }
};

/**
 * Obtiene el documento PDF de un email judicial
 * Reutiliza el endpoint de matching-bancario
 * @param {number} idEmail - ID del email
 * @returns {Promise<Blob>} Blob del PDF
 */
export const getMatchingJudicialDocumento = async (idEmail) => {
    try {
        const response = await getAuthAxios("default").get(
            `/matching-bancario/${idEmail}/documento`,
            {
                timeout: 75000,
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error al obtener documento:', error);
        throw error;
    }
};
